enum paymentTypeOptionsEnum {
  Payment = "Payment",
  AdvancePayment = "AdvancePayment",
  Deposit = "Deposit",
}

enum VehicleStatusEnum {
  Available = "Available",
  Rented = "Rented",
  Reserved = "Reserved",
  Maintenance = "Maintenance",
  Sold = "Sold",
}

enum TemplateReferenceType {
  CONTRACT = "Contract",
  BOOKING = "Booking",
  INVOICE = "Invoice",
  DAMAGE = "Damage",
  INSURANCE = "Insurance",
  TRAFFIC = "Traffic",
}

enum InsuranceProviderType {
  Customer = 1,
  Company = 2,
  Bonzah = 3,
  CreditCard = 4,
}

enum paymentStatusOptionsEnum {
  Pending = "Pending",
  Completed = "Completed",
  Failed = "Failed",
  Canceled = "Canceled",
  Disputed = "Disputed",
  Declined = "Declined",
  Refunded = "Refunded",
  PartiallyRefunded = "PartiallyRefunded",
  Authorized = "Authorized",
  PartiallyCaptured = "PartiallyCaptured",
  FullyCaptured = "FullyCaptured",
}

enum PaymentType {
  Payment = "Payment",
  Refund = "Refund",
  Deposit = "Deposit",
  AdvancePayment = "AdvancePayment",
  Release = "Release",
  Capture = "Capture",
}

enum PaymentMethodOptionsEnum {
  CreditCard = "CreditCard",
  DebitCard = "DebitCard",
  Cash = "Cash",
  BankTransfer = "BankTransfer",
  Cheque = "Cheque",
  MobilePayment = "MobilePayment",
  DirectBilling = "DirectBilling",
  Other = "Other",
}
enum CredirtCardTypeEnum {
  Visa = "Visa",
  Mastercard = "Mastercard",
  AmericanExpress = "American Express",
  Discover = "Discover",
  JCB = "JCB",
  DinersClub = "Diners Club",
  //  Other = "Other",
}

enum PaymentReferenceOptionsEnum {
  Booking = "Booking",
  Vehicle = "Vehicle",
}

enum AddOnChargeType {
  Fixed = "Fixed",
  // Percentage = "Percentage",
  PerDay = "PerDay",
}

enum WidgetType {
  AssetStatus = "AssetStatus",
  SalesStatics = "SalesStatics",
}

enum CommissionCalculationType {
  Fixed = 1,
  Percentage = 2,
}

enum VehicleOwnershipType {
  Lease = "lease",
  Purchase = "purchase",
}

enum leaseTerms {
  OneYear = "OneYear",
  TwoYear = "TwoYear",
  ThreeYear = "ThreeYear",
  FourYear = "FourYear",
  FiveYear = "FiveYear",
}

enum VendorType {
  Lease = 1,
  Purchase = 2,
  MaintenanceVendor = 3,
}

enum EarlyReturnPolicy {
  // Charge for the full, originally booked period (No Refund).
  ChargeFullPeriod = "ChargeFullPeriod",

  // Charge only for the actual time the car was used. This is more customer-friendly.
  ChargeActualDuration = "ChargeActualDuration",
}

enum PaymentDepositConfigType {
  VehicleConfig = 1,
  CustomerConfig = 2,
  ContractConfig = 3,
  VehicleTypeConfig = 4,
}

enum AdditionalDriverVisibility {
  All = "All",
  ContractOnly = "ContractOnly",
  BookingAndContract = "BookingAndContract",
}

export {
  paymentTypeOptionsEnum,
  paymentStatusOptionsEnum,
  PaymentMethodOptionsEnum,
  PaymentReferenceOptionsEnum,
  AddOnChargeType,
  VehicleStatusEnum,
  leaseTerms,
  WidgetType,
  CommissionCalculationType,
  VehicleOwnershipType,
  VendorType,
  EarlyReturnPolicy,
  CredirtCardTypeEnum,
  PaymentType,
  InsuranceProviderType,
  PaymentDepositConfigType,
  AdditionalDriverVisibility,
  TemplateReferenceType,
};
